import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";
import { isDspProductList } from "src/mocks/useProductInfo";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

// Dsf제품탭 파악
export const useIsDspProduct = () => {
  const [productKey, setProductName] = useRecoilState(productKeyAtom);
  // console.log(
  //   "ProductKeyList.includes(userInfo?.loginType)",
  //   ProductKeyList.includes(userInfo?.loginType),
  //   userInfo?.loginType
  // );
  // console.log("isDspProduct", productKey);

  return {
    isDspProduct: isDspProductList.includes(productKey ?? ""),
  };
};
